import {
	axiosPost
} from '../api/index.js';
import {
	axiosform
} from '../api/index.js';
import qs from 'qs';/* 请求数据转换处理 */
//封装函数传递
const ip = localStorage.getItem('IP');
// const ip = '222.211.90.98'; //后端公共ip和端口 https://new.cdtg.com.cn/
export default {
	imgUrl: 'https://m.cdtg.com.cn:8082',
	//imgUrl: 'https://new.cdtg.com.cn:8082',
	user: (id) => { /* 账户号拼接处理 */
		id=id.toString();
		if (id.length < 12) {
			let len = id.length;
			for (let i = 1; i < (12 - len); i++) {
				id = '0' + id;
			}
			id = '9' + id
		}
		return id
	},
	//获取数据
	getdata: (par, openId, code) => { /* 客户接口数据获取 */
		let params = qs.stringify({
			parms: par + ip,
			openId: openId,
			isWx:2,
			verificationCode: code
		})
		return axiosPost('app/tgzx/getTgzxData', params)
	},
	getdatalogin: (par, openId) => { /* 客户接口登录数据获取 */
		let params = qs.stringify({
			parms: par + ip,
			openId: openId,
			isWx:1
		})
		return axiosPost('app/tgzx/getTgzxData', params)
	},
	getcode: (par) => {/* 获取图片验证吗 */
		par = qs.stringify(par)
		return axiosPost('app/validCode/getValidCode', par)
	},
	getgetlist: (par) => {/* 公告和业务列表 */
		par = qs.stringify(par)
		return axiosPost('api/index/getlist', par,1)
	},
	getgetview: (par) => {/* 公告和业务详情 */
		par = qs.stringify(par)
		return axiosPost('api/index/getview', par,1)
	},
	getfile: (par) => {/* 须知文档获取 */
		par = qs.stringify(par)
		return axiosPost('api/index/agreement', par,1)
	},
	getShare: (par) => {/* 验证是否通过实名认证 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/getShareholderRealNameAuth', par)
	},
	loginOut: (par) => {/* 退出登录 */
		//par = qs.stringify(par)
		return axiosPost('app/webChat/loginOut?openId='+par)
	},
	getOpenId: (par) => {/* 验证是否通过实名认证 (通过openId查询)*/
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/getRealNameInfoByOpenId', par)
	},
	getRealNameInfoById: (par) => {/*根据id查询实名认证信息*/
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/getRealNameInfoById', par)
	},
	getphone: (par) => {/* 获取手机验证码(重置密码处) */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/sendMsgCode', par)
	},
	getwxphone: (par) => {/* 获取手机验证码 */
		par = qs.stringify(par)
		return axiosPost('app/validCode/sendMsgCode', par)
	},
	upload: (par) => {/* 文件上传 */
		return axiosform('app/file/uploadFile', par)
	},
	uploadkard: (par) => {/* 银行卡识别文件上传 */
		return axiosform('app/bankcard/bankcardORCBase64', par)
	},
	OpenAccount: (par) => {/* 开户 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/shareholderOpenAccount/addShareholderOpenAccount', par)
	},
	getAccount: (par) => {/* 开户 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/shareholderOpenAccount/getShareholderOpenAccount', par)
	},
	updAccount: (par) => {/* 更新开户信息 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/shareholderOpenAccount/updShareholderOpenAccount', par)
	},
	AuthResult: (par) => {/* 获取人脸识别地址 */
		par = qs.stringify(par)
		return axiosPost('app/realNameAuth/getDetectAuthResult', par)
	},
	getjudge: (par) => {/* 获取人脸识别结果 */
		par = qs.stringify(par)
		return axiosPost('app/realNameAuth/getDetectInfo', par)
	},
	ShareholderReal: (par) => {/* 保存实名信息 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/saveRealNameAuth', par)
	},
	listData: (par) => {/* 获取已申请业务列表 */
		par = qs.stringify(par)
		return axiosPost('app/bussinessapply/ccBussinessapply/listData', par)
	},
	listdetails: (par) => {/* 获取已申请业务列表 */
		par = qs.stringify(par)
		return axiosPost('app/bussinessapply/ccBussinessapply/getById', par)
	},
	addsave: (par) => {/* 新增业务申请 */
		par = qs.stringify(par)
		return axiosPost('app/bussinessapply/ccBussinessapply/save', par)
	},
	getBank: (par) => {/* 获取银行卡列表 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderBankcard/listData', par)
	},
	addBank: (par) => {/* 添加银行卡 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderBankcard/save', par)
	},
	plyPay: (par) => {/* 获取下单数据 */
		par = qs.stringify(par)
		return axiosPost('app/bussinessapply/ccBussinessapplyPay/order', par)
	},
	plyPays: (par) => {/* 获取下单数据 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/shareholderOpenAccount/order', par)
	},
	plyPayss: (par) => {/* 获取下单数据 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/order', par)
	},
	getPaydetails: (par) => {/* 获取下单详情 */
		par = qs.stringify(par)
		return axiosPost('app/bussinessapply/ccBussinessapply/getChargeByApplyId', par)
	},
	getNopay: (par) => {/* 获取支付失败详情 */
		par = qs.stringify(par)
		return axiosPost('app/bussinessapply/ccBussinessapplyPay/getNopay', par)
	},
	Journal: (par) => {/* 用户日志处理 */
		par = qs.stringify(par)
		return axiosPost('app/shareholderlog/ccShareholderLog/save', par)
	},
	getopenidaccount: (par) => {/* 根据openid获取开户信息 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/shareholderOpenAccount/getShareholderOpenAccountByOpenId', par)
	},
	getBizTokenByOpenId: (par) => {/* 根据openid获取人脸token */
		par = qs.stringify(par)
		return axiosPost('app/realNameAuth/getBizTokenByOpenId', par)
	},
	dORC: (par) => {/* 银行卡识别 */
		par = qs.stringify(par)
		return axiosPost('app/bankcard/bankcardORC', par)
	},
	getmoeny: (par) => {/* 获取过户过出预计费 */
		par = qs.stringify(par)
		return axiosPost('app/company/ccCompanyCode/getById', par)
	},
	getintro: (par) => {/* 获取介绍 */
		par = qs.stringify(par)
		return axiosPost('api/index/intro',par,1)
	},
	getRealNameBindByOpenId: (par) => {/* 根据openId获取账号绑定信息 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/getRealNameBindByOpenId',par)
	},
	getRealNameApplyByOpenId: (par) => {/* 根据openId获取实名认证申请信息 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/getRealNameApplyByOpenId',par)
	},
	updRealNameAuth: (par) => {/* 更新实名认证申请信息 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/updRealNameAuth',par)
	},
	getRealNameBindByCode: (par) => {/* 根据股东账号查询账号信息 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/getRealNameBindByCode',par)
	},
	checkRealNameAuthApply: (par) => {/* 是否已经提交实名认证 */
		par = qs.stringify(par)
		return axiosPost('app/shareholder/ccShareholderRealNameAuth/checkRealNameAuthApply',par)
	},
	
}
